import { render } from "./ReferralHeader.vue?vue&type=template&id=15948e2e"
import script from "./ReferralHeader.vue?vue&type=script&lang=js"
export * from "./ReferralHeader.vue?vue&type=script&lang=js"

import "./ReferralHeader.vue?vue&type=style&index=0&id=15948e2e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__